import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { getPricingPageUrl } from '../../DiscountKey';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface Subscription {
  plan: string;
  [key: string]: any;
}

interface Digistore {
  [key: string]: any;
}

interface UpgradeSlideshowAccountModalProps {
  isOpen: boolean;
  subscription: Subscription;
  digistore: Digistore;
  setUpgradeSlideshowAccountOpenState: (payload: any) => void;
}

const UpgradeSlideshowAccountModal: React.FC<UpgradeSlideshowAccountModalProps> = ({
  isOpen,
  setUpgradeSlideshowAccountOpenState,
  subscription,
  digistore
}) => (
  <Modal
    centered
    isOpen={isOpen}
    toggle={() => setUpgradeSlideshowAccountOpenState(!isOpen)}
    wrapClassName="modal-dark"
    size="sm"
  >
    <ModalHeader toggle={() => setUpgradeSlideshowAccountOpenState(!isOpen)}>
      {getTranslationKey('upgradeAccount')}
    </ModalHeader>
    <ModalBody>
      <p>{getTranslationKey('slideshowUpgradeAccountHint')}</p>

      <Button
        className="w-100-p m-b-30"
        color="success"
        href={
          subscription.plan === 'free'
            ? getPricingPageUrl(digistore, {
                utm_medium: 'upgrade-popup-button',
                utm_campaign: 'builder-upgrades',
                utm_source: 'builder'
              })
            : 'https://scrappbook.de/slideshows-fuer-fotografen/'
        }
        target={subscription.plan === 'free' ? '_self' : '_blank'}
        onClick={() => {
          setUpgradeSlideshowAccountOpenState(false);
        }}
      >
        {subscription.plan === 'free'
          ? getTranslationKey('upgradeAccount')
          : getTranslationKey('showSlideshowPricing')}
      </Button>
    </ModalBody>
  </Modal>
);

function mapStateToProps({
  auth: { upgradeSlideshowAccountIsOpen, digistore, subscription }
}: any) {
  return { isOpen: upgradeSlideshowAccountIsOpen, digistore, subscription };
}

export default connect(mapStateToProps, actions)(UpgradeSlideshowAccountModal);
